(function(window, angular) {
    'use strict';

    angular.module('wtApp.dataService', [
        'ui.router',
        'wtApp.wtCommon',
        'wtApp.constants',
        'wtApp.wtTracking',
        'wtQueryBuilder'
    ])
        .config(['$qProvider', function($qProvider) {
            $qProvider.errorOnUnhandledRejections(false);
        }])
        .constant('IS_HEADLESS', isHeadlessBrowser())
        .constant('IS_PRINT_CLIENT', isPrintClient())
        .run(['$rootScope', function($rootScope) {
            $rootScope.INIT_ANALYSIS_LOAD = $rootScope.INIT_ANALYSIS_LOAD || {};
        }]);

    /**
     *
     * Identifies any phantomJS environment
     * @returns {boolean} Id headless browser flag
     */
    function isHeadlessBrowser() {
        return (typeof window.callPhantom === 'function');
    }

    /**
     * Identifies the chart-to-pic environment
     * When running in chart-to-pic mode, no auth is required and all the data should be injected into the page prior to
     * angularJS kicks in
     * @returns {boolean} Is print client flag
     */
    function isPrintClient() {
        /**
         * The print client injects a parameter into the URL to help distinguish that the application is running in a phantomJS print environment
         * @type {string}
         */
        const PRINT_CLIENT_FLAG = 'print-service';
        const search = window.location.search || '';

        return (search.indexOf(PRINT_CLIENT_FLAG) >= 0);
    }
})(window, window.angular);
